import { PaxCheckIcaoSex } from "../../api";

enum Gender {
  Male = "male",
  Female = "female",
  Unspecified = "unspecified",
}

export function GenderFromLetter(letter: string): Gender {
  switch (letter.toUpperCase()) {
    case "M":
      return Gender.Male;
    case "F":
      return Gender.Female;
    default:
      return Gender.Unspecified;
  }
}

export function GenderFromApi(sex: PaxCheckIcaoSex): Gender {
  switch (sex) {
    case PaxCheckIcaoSex.F:
      return Gender.Female;
    case PaxCheckIcaoSex.M:
      return Gender.Male;
    case PaxCheckIcaoSex.X:
      return Gender.Unspecified;
  }
}

export function GenderToApi(gender: Gender): PaxCheckIcaoSex {
  switch (gender) {
    case Gender.Female:
      return PaxCheckIcaoSex.F;
    case Gender.Male:
      return PaxCheckIcaoSex.M;
    case Gender.Unspecified:
      return PaxCheckIcaoSex.X;
  }
}

export default Gender;
